"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.finlandTranslations = void 0;
var _types = require("../../../types");
const finlandTranslations = exports.finlandTranslations = {
  [_types.ErrorPageTranslationKey.headline]: 'Anteeksi!',
  [_types.ErrorPageTranslationKey.buttonText]: 'Takaisin',
  [_types.ErrorPageTranslationKey.text]: 'Sivu ei ole käytössä tällä hetkellä',
  [_types.ErrorPageTranslationKey.notFound]: 'Etsimääsi sivua ei valitettavasti löydy',
  [_types.ErrorPageTranslationKey.unauthorized]: 'Hakemallesi sivulle pääsy on rajoitettu ja kaikki vaatimukset eivät täyty.',
  [_types.ErrorPageTranslationKey.contactSupportTeam]: 'Ota yhteyttä Oriflamen tukitiimiin sähköpostitse:',
  [_types.ErrorPageTranslationKey.rejectedUrl]: 'Pyydetty URL-osoite hylättiin!'
};
